import { render } from "./IconStarRounded.vue?vue&type=template&id=61c82bc8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconStarRounded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61c82bc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61c82bc8', __exports__)) {
    api.reload('61c82bc8', __exports__)
  }
  
  module.hot.accept("./IconStarRounded.vue?vue&type=template&id=61c82bc8", () => {
    api.rerender('61c82bc8', render)
  })

}


export default __exports__